import * as Turbo from '@hotwired/turbo'
Turbo.start()

import '../controllers'
import '~/stylesheets/application.css'
